<template>
  <div>
    <pxkeji-rightHeader/>

    <div class="pxkeji-right-box" style="display:none">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="用户ID">
              <a-input placeholder="请输入用户ID" v-model="where.keyword.uid"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="角色名称">
              <a-input placeholder="请输入角色名称" v-model="where.keyword.roleName"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" @click="searchList" v-btnlimit="'角色列表-搜索'">搜索</a-button>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="clear">清空</a-button>
            <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
              {{ expand?"闭合":"高级搜索" }}
              <a-icon :type="expand ? 'up' : 'down'"/>
            </a>
          </a-col>
        </a-row>-->
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn
        name="添加"
        class="pxkeji_basic_btn"
        v-btnlimit="'角色列表-添加'"
        @click="showInfo(0)"
        type="primary"
      />
      <!-- <pxkeji-btn
        name="批量导出"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      /> -->
      <pxkeji-btn
        name="批量启用"
        v-btnlimit="'角色列表-批量启用'"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchEnable"
      />
      <pxkeji-btn
        name="批量禁用"
        v-btnlimit="'角色列表-批量禁用'"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
        @click="batchDisEnable"
      />

      <a-alert type="info" showIcon style="margin-bottom:20px;display:none">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
       <span slot="admin" slot-scope="admin">
          <a-tag v-if="admin" color="green">后台</a-tag>
          <a-tag v-else color="red">前台</a-tag>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            v-btnlimit="'角色列表-编辑'"
            size="small"
            type="primary"
            @click="showInfo(action)"
          />
          <a-divider type="vertical"/>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                  name="禁用"
                  size="small"
                  v-btnlimit="'角色列表-启用禁用'"
                  type="default"
                  class="pxkeji_dro_btn"
                  @click="handleProhibit(action.id,0)"
                  v-if="action.status==1"
                />
                <pxkeji-btn
                  name="启用"
                  v-btnlimit="'角色列表-启用禁用'"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  @click="handleProhibit(action.id,1)"
                  v-else
                />
              </a-menu-item>
              <a-menu-item key="2" v-if="action.systemLevel != 99">
                <pxkeji-btn
                  name="删除"
                  v-btnlimit="'角色列表-删除'"
                  size="small"
                  type="default"
                  class="pxkeji_dro_btn"
                  @click="delInfo(action.id)"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed">
              更多
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      :footer="false"
      destroyOnClose
      width="60%"
       :maskClosable="false"
    >
      <info @callbackMethod="save" :infos="addedit.info"/>
    </a-modal>
  </div>
</template>
<script>
var that;
import info from "./roleInfo.vue";

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "角色id"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "角色名称"
  },
  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "创建时间"
  },
  {
    dataIndex: "admin",
    key: "admin",
    align: "center",
    title: "角色",
    scopedSlots: { customRender: "admin" }
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "userlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 99999 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          uid: "",
          roleName: ""
        }
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false //弹框
    };
  },
  components: {
    info: info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取用户列表
      this.isloading = true;
      this.clearRows();
      this.$api.role
        .getAll()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info) {
      //打开弹出框
       this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.role
        .chanageStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.role
            .del(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

